import { Box, Card, CardBody, Flex, Text, Icon, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { IoChevronForwardOutline } from "react-icons/io5";
import { useParams } from 'react-router-dom';
import api from "../servicos/Api";
import Header from "../container/Header";

const Notificacoes = () => {

    const [notificacoes, setNotificacoes] = useState([]);
    const [notificacao, setNotificacao] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const { parametro } = useParams();
    useEffect(() => {
        getNotificacoes();
        if(parametro && parametro != 'undefined'){
            OnclickNotification(parametro);
        }
    }, []);

    const OnclickNotification = async (id) => {
        console.log(parametro);
        const response = await api.post('/login_app/get_notificacao', {'seq': id});

        if(response.data.error === false){
            visualizar(response.data.data[0]); 
        }
    };

    const getNotificacoes = async () => {
        const response = await api.post('/login_app/get_notificacoes');
        var c = 0;
        if(response.data.error === false){
            setNotificacoes(response.data.data);
            response.data.data.map(n => ( !n.visualizado ? c += 1 : '' ));
        }
        const elemento = document.querySelector('.notification-alert');
        if(c != 0){
            elemento.textContent = c;
        } else {
            elemento.remove();
        }
       
    };

    const visualizar = async (notificacao) => {
        setNotificacao(notificacao); 
        setIsOpen(true); 
        const response = await api.post('/login_app/visualizar_notificacao', {notificacao : notificacao});
        if(response.data.error === false){
            console.log(response.data.data);
        } 
    }

    const CardNotificacao = (props) => {
        return(<Card key={'noti'+props.n.seq_notificacao} mb='1' onClick={() => visualizar(props.n)} style={{borderLeft: ( !props.n.visualizado  ? 'solid 5px #00a0e6' : '' )}}  /*style={{background: ( !props.n.visualizado  ? 'rgb(0 160 230 / 25%)' : '' )}}*/>
                <CardBody style={{borderLeft: ( !props.n.visualizado  ? 'solid 5px black' : '' ), marginLeft : ( !props.n.visualizado  ? '2.5px' : '10px' )}}>
                    <Flex justifyContent='space-between' alignItems='center'>
                        <Flex direction='column'>
                            <Text lineHeight='1.2' style={{fontWeight: ( !props.n.visualizado  ? '700' : '' )}}  >{props.n.titulo}</Text>
                            <Text fontSize='sm' >{props.n.dt_criacao_format}</Text>
                        </Flex>
                        <Icon as={IoChevronForwardOutline} boxSize='5'/>
                    </Flex>
                </CardBody>
            </Card>);
    };

    return(
        <>
        <Box p='4'>
            {notificacoes.map(n => <CardNotificacao n={n}/>)}
        </Box>
        <Drawer
            isOpen={isOpen}
            placement='right'
            onClose={() => {setIsOpen(false); getNotificacoes();}}
            size='md'
        >
            <DrawerOverlay />
            <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>Notificação</DrawerHeader>

            <DrawerBody>
                {notificacao ? <>
                <Text fontWeight='bold' lineHeight='1.2'>{notificacao.titulo}</Text>
                <Text mb='6' fontSize='sm'>{notificacao.dt_criacao_format}</Text>
                <Text>{notificacao.corpo}</Text>
                </> : ''}
            </DrawerBody>
            </DrawerContent>
        </Drawer>
        </>
    );
};

export default Notificacoes;